import React from 'react';
import { NavObjectType, lddGlobalSessionInfo } from '../../Components/navigationTypes';
import { MainIFrame } from './navManager';
import Loading from '../../Components/Loading';
import DsMainPage from './DsMainPage';
import "./MainPage.css"

const MainPage = (props: {
    info: lddGlobalSessionInfo,
    page: NavObjectType,
    dataroot: any,
    reactFileComponent: React.JSX.Element
}) => {
    
    function GetMainComponent(): React.ReactElement {
        if (props.info) {
            let component;
            switch (props.page.component) {
                case 'main':
                    return <></>;
                case 'formlist':
                    component = <DsMainPage />;
                    break;
                case 'billing':
                    component = <MainIFrame page={props.page} sid={props.info.sid} />;
                    break;
                default:
                    break;
            }
            return component;
        } else {
            return <Loading />;
        }
    }

    return (
        <div className={"file-list"} >
            {GetMainComponent()}
        </div>
    )
}

export default MainPage;